/* @ngInject */
function QuoteTemplateFactory($http, $rootScope, QuoteSectionSnapshot) {
  class QuoteTemplate {
    constructor(data) {
      this.name = null;
      this.createdAt = null;
      this.updatedAt = null;
      this.sections = [];
      this.content = null;
      this.currency = null;
      this.language = null;
      this.shared = {
        isShared: false,
      };

      if (data) this.setData(data);
    }

    setData(templateData) {
      this._id = templateData._id ? templateData._id : undefined;
      this.name = templateData.name;
      this.createdAt = templateData.createdAt ? templateData.createdAt : undefined;
      this.updatedAt = templateData.updatedAt ? templateData.updatedAt : undefined;
      this.content = templateData.content;
      this.currency = templateData.currency;
      this.language = templateData.language;
      this.shared = {
        isShared: templateData.shared.isShared,
        sharedBy: templateData.organization ? templateData.organization.name : undefined,
        importCode: templateData.shared.importCode ? templateData.shared.importCode : undefined,
        importedBy: templateData.shared.importedBy ? templateData.shared.importedBy : [],
      };

      if (templateData.sections) {
        for (let i = 0; i < templateData.sections.length; i++) {
          if (templateData.sections[i].sectionType === "pricingTable") {
            templateData.sections[i].pricingTable.currency = this.currency;
            templateData.sections[i].pricingTable.exchangeInfo = $rootScope.organization.exchangeRates;
          }
          if (this.sections[i]) this.sections[i].setData(templateData.sections[i]);
          else this.sections.push(new QuoteSectionSnapshot(templateData.sections[i], null, this.currency));
        }

        if (this.sections.length > templateData.sections.length) {
          this.sections = this.sections.slice(0, templateData.sections.length);
        }
      } else {
        this.sections = [new QuoteSectionSnapshot(null, null, this.currency)];
      }
    }

    isShared() {
      return this.shared.isShared;
    }

    static getResourceUrl() {
      return `${process.env.SERVER_URL}/api/secure/organization/${$rootScope.organization.slug}/quote-templates`;
    }

    static query(params) {
      return $http
        .get(QuoteTemplate.getResourceUrl(), { params })
        .then((response) => response.data.map((quoteTemplateData) => new QuoteTemplate(quoteTemplateData)));
    }

    static getDefaultTemplates() {
      return $http
        .get(`${QuoteTemplate.getResourceUrl()}/default`)
        .then((response) => response.data.map((quoteTemplateData) => new QuoteTemplate(quoteTemplateData)));
    }

    static getImportedTemplates() {
      return $http.get(`${QuoteTemplate.getResourceUrl()}/imported`).then((response) => {
        return response.data.map((quoteTemplateData) => new QuoteTemplate(quoteTemplateData));
      });
    }

    static create(name, quoteId) {
      return $http
        .post(QuoteTemplate.getResourceUrl(), {
          name: name,
          fromQuote: quoteId,
        })
        .then((response) => new QuoteTemplate(response.data));
    }

    static importTemplate(importCode) {
      return $http
        .post(`${QuoteTemplate.getResourceUrl()}/import`, {
          importCode: importCode,
        })
        .then((response) => new QuoteTemplate(response.data));
    }

    static overwrite(quoteTemplateId, quoteId) {
      return $http
        .put(`${QuoteTemplate.getResourceUrl()}/${quoteTemplateId}`, {
          fromQuote: quoteId,
        })
        .then((response) => new QuoteTemplate(response.data));
    }

    delete() {
      return $http.delete(`${QuoteTemplate.getResourceUrl()}/${this._id}`).then(() => true);
    }

    deleteImported() {
      return $http
        .put(`${QuoteTemplate.getResourceUrl()}/import-delete`, {
          quoteTemplateId: this._id,
        })
        .then((response) => {
          this.updatedAt = response.data.updatedAt;
          this.shared = response.data.shared;
          return this;
        });
    }

    share() {
      return $http
        .put(`${QuoteTemplate.getResourceUrl()}/${this._id}/share`, {
          shared: { isShared: true },
        })
        .then((response) => {
          this.updatedAt = response.data.updatedAt;
          this.shared = response.data.shared;
          return this;
        });
    }

    unshare() {
      return $http
        .put(`${QuoteTemplate.getResourceUrl()}/${this._id}/share`, {
          shared: { isShared: false },
        })
        .then((response) => {
          this.updatedAt = response.data.updatedAt;
          this.shared = response.data.shared;
          return this;
        });
    }

    editName(name) {
      return $http
        .put(`${QuoteTemplate.getResourceUrl()}/${this._id}/edit-name`, {
          name: name,
        })
        .then((response) => {
          this.name = response.data.name;
          return this;
        });
    }
  }

  return QuoteTemplate;
}

export default QuoteTemplateFactory;
